import { useMemo } from 'react';
import { useSociety } from '@/features/societies/hooks/useSocieties';

/**
 * Résout le societyId effectif pour la récupération des garanties.
 * Basé sur la "Stratégie de garantie" (warrantyPolicyOwnerId).
 */
export const useEffectiveSocietyId = (societyId: string | undefined): string | undefined => {
  const { data: society } = useSociety(societyId);

  return useMemo(() => {
    if (!society || !societyId) return societyId;

    const warrantyPolicyOwnerId = society.groupConfiguration?.warrantyPolicyOwnerId ?? society.ownConfiguration?.warrantyPolicyOwnerId ?? null;
    if (warrantyPolicyOwnerId && warrantyPolicyOwnerId !== societyId) {
      return warrantyPolicyOwnerId;
    }

    return societyId;
  }, [society, societyId]);
};
